import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import {
  makeSelectPageValidations,
  makeSelectMonthOptions,
  makeSelectDateOptions,
  makeSelectNricIssueYearOptions,
  makeSelectAuthorizedUserValues,
  makeSelectAuthorizeUserForm,
  makeSelectAuthorizerDeliveryPayload
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import { changeFormField, submitAuthorizeDelivery } from "ducks/actions";
import validate, { asyncValidate } from "validations";
import isEmpty from "lodash/isEmpty";

const AuthorizationForm = Component =>
  function Comp(props) {
    const { initialValues, changeField, token } = props;
    useEffect(() => {
      changeField("token", token);
    }, [changeField, initialValues, token]);
    // const { value, message } = get(scheduleDeliveryDetails, "eligibility");
    // if (!value) {
    //   return <NotEligible description={message} />;
    // }
    return <Component {...props} />;
  };

const mapStateToProps = (_, props) => {
  return createStructuredSelector({
    formValidations: makeSelectPageValidations(forms.AUTHORIZER_FORM),
    formValues: makeSelectAuthorizeUserForm(),
    payload: makeSelectAuthorizerDeliveryPayload(),
    monthOptions: makeSelectMonthOptions(),
    dateOptions: makeSelectDateOptions(),
    yearOptions: makeSelectNricIssueYearOptions(),
    initialValues: makeSelectAuthorizedUserValues()
  });
};

export function mapDispatchToProps(dispatch) {
  return {
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.AUTHORIZER_FORM,
          field: field,
          value: value
        })
      );
    },
    onSubmit: (navigate, payload) => {
      dispatch(
        submitAuthorizeDelivery(payload, (_, error) => {
          isEmpty(error) && navigate();
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.AUTHORIZER_FORM,
    destroyOnUnmount: false,
    validate,
    asyncValidate
  }),
  memo
)(AuthorizationForm(SmartRender));
